import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import emailsApi from "../services/emails";
import authApi from "../services/auth";
import videoApi from "../services/video";
import eventApi from "../services/event";
import reviewApi from "../services/review";
import galleryApi from "../services/gallery";
import fileApi from "../services/file";
import audioApi from "../services/audio";
import brandApi from "../services/brand";
import businessConfigApi from "../services/businessConfig";
import aiEmailsApi from "../services/aiEmails";
import equipmentApi from "../services/equipment";
import expensesApi from "../services/expenses";
import gmailApi from "../services/gmail";
import integrationsApi from "../services/integrations";
import songRequestsApi from "../services/songRequests";
import leadLogApi from "../services/leadLog";
import serviceCatalogApi from "../services/serviceCatalog";
import eventTypesApi from "../services/eventTypes";
import availabilityRulesApi from "../services/availabilityRules";
import portalApi from "../services/portal";
import portalAdminApi from "../services/portalAdmin";
import v4PublicApi from "../services/v4PublicApi";
import adminApi from "../services/admin";

const store = configureStore({
  reducer: {
    [emailsApi.reducerPath]: emailsApi.reducer,
    [aiEmailsApi.reducerPath]: aiEmailsApi.reducer,
    [equipmentApi.reducerPath]: equipmentApi.reducer,
    [expensesApi.reducerPath]: expensesApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [videoApi.reducerPath]: videoApi.reducer,
    [eventApi.reducerPath]: eventApi.reducer,
    [reviewApi.reducerPath]: reviewApi.reducer,
    [galleryApi.reducerPath]: galleryApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [audioApi.reducerPath]: audioApi.reducer,
    [brandApi.reducerPath]: brandApi.reducer,
    [businessConfigApi.reducerPath]: businessConfigApi.reducer,
    [gmailApi.reducerPath]: gmailApi.reducer,
    [integrationsApi.reducerPath]: integrationsApi.reducer,
    [songRequestsApi.reducerPath]: songRequestsApi.reducer,
    [leadLogApi.reducerPath]: leadLogApi.reducer,
    [serviceCatalogApi.reducerPath]: serviceCatalogApi.reducer,
    [eventTypesApi.reducerPath]: eventTypesApi.reducer,
    [availabilityRulesApi.reducerPath]: availabilityRulesApi.reducer,
    [portalApi.reducerPath]: portalApi.reducer,
    [portalAdminApi.reducerPath]: portalAdminApi.reducer,
    [v4PublicApi.reducerPath]: v4PublicApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(emailsApi.middleware)
      .concat(aiEmailsApi.middleware)
      .concat(equipmentApi.middleware)
      .concat(expensesApi.middleware)
      .concat(authApi.middleware)
      .concat(videoApi.middleware)
      .concat(eventApi.middleware)
      .concat(reviewApi.middleware)
      .concat(galleryApi.middleware)
      .concat(fileApi.middleware)
      .concat(audioApi.middleware)
      .concat(brandApi.middleware)
      .concat(businessConfigApi.middleware)
      .concat(gmailApi.middleware)
      .concat(integrationsApi.middleware)
      .concat(songRequestsApi.middleware)
      .concat(leadLogApi.middleware)
      .concat(serviceCatalogApi.middleware)
      .concat(eventTypesApi.middleware)
      .concat(availabilityRulesApi.middleware)
      .concat(portalApi.middleware)
      .concat(portalAdminApi.middleware)
      .concat(v4PublicApi.middleware)
      .concat(adminApi.middleware),
});

setupListeners(store.dispatch);

export default store;
